import React from 'react';
import styled from 'styled-components';
import Cabecalho from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Menu from '../menu/Menu';
import Titulo from '../titulo/Titulo';
import ExperienciasSection from './ExperienciasSection';

// =============================================================================
// PÁGINA: /experiencias
// =============================================================================
// - Página dedicada para a seção de Experiências com o layout padrão do app
//   (Menu lateral + Cabecalho + Container centralizado + Rodape)
// - A mesma seção também é renderizada DENTRO de /gerenciar-publicadores
//   (logo abaixo da tabela de publicadores)
// - Acessível via ProtectedAdminRoute (admin / coordenador-geral / colaborador)
// =============================================================================

const PageWrapper = styled.div`
    min-height: 100vh;
    background: #fff;
`;

const MainContent = styled.main`
    padding-top: 85px;
    padding-left: 260px;
    padding-right: 24px;
    padding-bottom: 60px;
    box-sizing: border-box;
    @media (max-width: 1200px) and (min-width: 768px) {
        padding-left: 80px;
    }
    @media (max-width: 767px) {
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
    }
`;

const Container = styled.div`
    padding: 24px;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Roboto', sans-serif;
`;

export default function Experiencias() {
    return (
        <PageWrapper>
            <Menu />
            <Cabecalho />
            <MainContent>
                <Container>
                    <Titulo>Experiências</Titulo>
                    <ExperienciasSection />
                </Container>
            </MainContent>
            <Rodape />
        </PageWrapper>
    );
}
